import script from "./addBlacklistModel.vue?vue&type=script&setup=true&lang=jsx"
export * from "./addBlacklistModel.vue?vue&type=script&setup=true&lang=jsx"

import "./addBlacklistModel.vue?vue&type=style&index=0&id=137c8698&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-137c8698"]])

export default __exports__